export const priceNormelizer = (strings, ...params) => {
  let result = "";
  for (let i = 0; i < strings.length; i++) {
    result += strings[i];
    if (i < params.length) {
      let currentParam = params[i];
      if (!Number.isNaN(parseFloat(currentParam))) {
        const asNumber = Number(currentParam);
        const rounded = Math.round(asNumber);
        currentParam = rounded.toLocaleString();
      }
      result += currentParam;
    }
  }
  return result;
};

export const noUndefStrings = (strings, ...params) => {
  let result = "";
  for (let i = 0; i < strings.length; i++) {
    result += strings[i];
    if (i < params.length) {
      let currentParam = params[i];
      if (!currentParam) {
        result += "";
      } else {
        result += currentParam;
      }
    }
  }
  return result;
};



// WEBPACK FOOTER //
// ./src/helpers/tags.js